<div class="container row flex-height">
    <div class="slider flex-child grow container col flex-height" #slider>
        <div *ngIf="uniqueValueInfoRenderers.length" class="column flex-child grow container col flex-height">
            <div class="unique-value-header flex-child">
                <h3>Unique Values</h3>
                <i>Click on a color block to change colors</i>
            </div>
            <div class="unique-values flex-child">
                <div class="unique-value" *ngFor="let colorBlock of uniqueValueInfoRenderers[0].uniqueValueInfos; index as i">
                    <mc-color-picker-ng
                                        class="unique-color color-swatch"
                                        [color]="colorBlock.symbol.style !== 'none' ? colorBlock.symbol.color : colorBlock.symbol.outline.color"
                                        (openPicker)="colorBlock.symbol.style !== 'none' ? openClassColorPicker(i, colorBlock.symbol.color) : openClassColorPicker(i, colorBlock.symbol.outline.color)"
                                        (colorChange)="updateColorFromPicker($event, i, 'uniqueValueInfos')">
                    </mc-color-picker-ng>
                    <div class="unique-color-text-div">
                        <div class="unique-color-text">{{ colorBlock.label }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="flex-child grow container col flex-height" style="max-width: 55%; padding-left: 15px;">
        <div class="options flex-child container row">
            <label class="flex-child option-label">
                <b>Field:</b>
                <select #fieldSelect (change)="generateRenderer(true)" [(ngModel)]="selectedField">
                    <option *ngFor="let column of layerColumns" [value]="column.name">{{ column.alias }}</option>
                </select>
                <label class="toggle-switch" [ngClass]="{'disabled': (!(isNumericData || isDate) || loadingData)}">
                    <span class="toggle-label left font-size--1">Range</span>
                    <input type="checkbox" class="toggle-switch-input" [checked]="forceUniqueValues" (click)="resetValidation(); forceUpdateWithUniqueValues(!forceUniqueValues)" [disabled]="!(isNumericData || isDate) || loadingData">
                    <span class="toggle-switch-track margin-right-1"></span>
                    <span class="toggle-label font-size--1">Unique</span>
                  </label>
            </label>
            <label class="flex-child option-label">
                <b>Classes: </b>
                <input #classes type="number" [min]="minClasses" [max]="maxClasses" (input)="changeClassBreaks($event)" />
                <i *ngIf="classes && classes.disabled === false">You can set between {{ minClasses }} and {{ maxClasses }} class breaks</i>
                <i *ngIf="classes && classes.disabled === true"> This field contains unique values so number of classes can not be set</i>
            </label>
        </div>
        <div *ngIf="!errorMessage && !loadingData" class="color flex-child grow container row flex-height-fix">
            <div *ngIf="classBreakInfoRenderers.length" class="column flex-child grow container col">
                <div class="unique-value-header flex-child">
                    <h3>Class Breaks</h3>
                    <i>Click on a color block to change colors</i>
                </div>
                <div class="unique-values flex-child">
                    <div class="block-group" style="margin: 0;">
                        <div class="block" *ngFor="let colorBlock of classBreakInfoRenderers[0].classBreakInfos; index as i">
                            <mc-color-picker-ng
                                                class="color-swatch"
                                                [color]="colorBlock.symbol.style !== 'none' ? colorBlock.symbol.color : colorBlock.symbol.outline.color"
                                                (openPicker)="colorBlock.symbol.style !== 'none' ? openClassColorPicker(i, colorBlock.symbol.color) : openClassColorPicker(i, colorBlock.symbol.outline.color)"
                                                (colorChange)="updateColorFromPicker($event, i, 'classBreakInfos')">
                            </mc-color-picker-ng>
                            <div class="block-text">
                                Min: {{ colorBlock.minValue }}<br>
                                Max: {{ colorBlock.maxValue }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="errorMessage" class="color alert-yellow is-active flex-child">
            {{ errorMessage }}
        </div>
        <div *ngIf="loadingData && !errorMessage" class="loader is-active padding-leader-3 padding-trailer-3 color flex-child">
            <div class="loader-bars"></div>
            <div class="loader-text">Loading...</div>
        </div>
        <div class="actions flex-child" style="margin-top: 5px;">
            <button class="btn" (click)="themeLayer()">Okay</button>
            <button class="btn" (click)="deThemeLayer()" [disabled]="errorMessage">De-Theme Layer</button>
            <button class="btn" (click)="splitLayer()" [disabled]="errorMessage">Split Layer</button>
        </div>
    </div>
</div>
